import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadMomentOperation = 'ReadMomentsV2'

export type ReadMomentV2ResponseData = OpalApiResponseDocument<
  ReadMomentOperation,
  200
>

export type ReadMomentV2RequestParams =
  OpalApiRequestParams<ReadMomentOperation>

export function readMoments(
  params: ReadMomentV2RequestParams
): Promise<ReadMomentV2ResponseData> {
  const url = new URL('/moments/v2', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get<ReadMomentV2ResponseData>(url.toString())
    .then((res) => res.data)
}
